var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReceitaForm',{ref:"ReceitaForm",attrs:{"form":_vm.form,"model":_vm.model,"is-pendente":_vm.isPendente},on:{"save":function($event){return _vm.handleSave()},"registrarNaoAtendido":function($event){return _vm.$emit('registrarNaoAtendido', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }